import React from "react";
import bag from "../../Assets/images/backpack.png";
import "./styles.css";
import HeroSectionSvg from "./HeroSectionSvg";
import Fade from "react-reveal/Fade";
const LandingPage = () => {
  return (
    <>
      <div className="a-landing-page-pattern"></div>
      <div className="a-landing-page-wrapper position-relative">
        <div className="hero-section-svg d-none d-md-block d-lg-block">
          <HeroSectionSvg />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <section className="a-landingp-page-caption">
                <Fade delay={600} left>
                  {" "}
                  <h4>INTRODUCING</h4>{" "}
                </Fade>
                <h1>MY TRIBE PACK</h1>

                <Fade delay={1000} left>
                  {" "}
                  <p>Made for modern designers</p>{" "}
                </Fade>
                <Fade delay={1200} bottom>
                  {" "}
                  <button>Coming Soon!</button>
                </Fade>
              </section>
            </div>
            <div className="col-md-6 small-mt-3">
              <img
                src={bag}
                alt="Aorthar Merch Collection"
                className="a-landing-page-img w-100"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
